export const SET_AUTH = 'SET_AUTH';
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const SET_USUARIO = 'SET_USUARIO';
export const SET_NEGOCIO = 'SET_NEGOCIO';
export const REMOVE_AUTH = 'REMOVE_AUTH';
